// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Header_Slider__1RTOS","Description":"Header_Description__11VmO","Button":"Header_Button__kTrrH"};